import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@ami/react/core';
import { LocationSearchInput } from '@ami/react/core';

const ShipTo = ({
  location,
  selectedDealerBranch,
  onShowCustomShippingLocation,
  showCustomShippingLocation,
  onLocationChange,
}) => {
  return (
    <React.Fragment>
      <Dropdown
        items={[
          {
            id: 0,
            label: `Dealer Branch ${
              selectedDealerBranch ? `(${selectedDealerBranch.label})` : ''
            }`,
          },
          { id: 1, label: 'Custom' },
        ]}
        selectedId={showCustomShippingLocation ? 1 : 0}
        onChange={(selectedId) =>
          onShowCustomShippingLocation(selectedId === 1 ? true : false)
        }
      />
      {showCustomShippingLocation && (
        <LocationSearchInput
          id="CustomShippingLocation"
          className="mb-0 mt-2"
          placeholder="Custom shipping location"
          location={location}
          onLocationChange={onLocationChange}
          required={true}          
        />
      )}
    </React.Fragment>
  );
};

ShipTo.propTypes = {
  location: PropTypes.any,
  selectedDealerBranch: PropTypes.any,
  onShowCustomShippingLocation: PropTypes.func.isRequired,
  showCustomShippingLocation: PropTypes.bool.isRequired,
  onLocationChange: PropTypes.func.isRequired,
};

export default ShipTo;
